<template>
  <section class="belief-section" aria-labelledby="belief-title">
    <div class="belief-inner">
      <header class="belief-header">
        <h2 id="belief-title" class="belief-title">In cosa crediamo</h2>
      </header>
      <div class="belief-grid">
        <article class="belief-item">
          <h3 class="belief-item-title">Evidenze prima delle opinioni</h3>
          <p class="belief-item-text">
            Ogni scelta che facciamo — dai protocolli alla piattaforma — parte da evidenze scientifiche, non da intuizioni. È il nostro modo di garantire qualità e sicurezza.
          </p>
        </article>
        <article class="belief-item">
          <h3 class="belief-item-title">Accessibilità reale</h3>
          <p class="belief-item-text">
            La preparazione atletica professionale non deve essere un privilegio di chi ha grandi budget. Lavoriamo perché sia alla portata di ogni società sportiva.
          </p>
        </article>
        <article class="belief-item">
          <h3 class="belief-item-title">Adattabilità al contesto</h3>
          <p class="belief-item-text">
            Nessuna società sportiva è uguale a un'altra. I nostri strumenti e metodi si adattano a risorse, spazi, livelli e obiettivi reali.
          </p>
        </article>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'OurBeliefSection'
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/colors.scss";

.belief-section {
  background-color: $white;
  color: $black;
}

.belief-inner {
  padding: 56px 24px;
  display: flex;
  flex-direction: column;
  gap: 32px;
}

.belief-header {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.belief-title {
  margin: 0;
  font-size: 2rem;
  font-weight: 700;
  line-height: 1.2;
}


.belief-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
}

.belief-item {
  border: 1px solid $black;
  border-radius: 25px;
  color: $black;
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.belief-item-title {
  margin: 0;
  font-size: 1.5rem;
  font-weight: 700;
  text-align: left;
}

.belief-item-text {
  margin: 0;
  font-size: 1.1rem;
  line-height: 1.6;
  flex: 1;
  display: flex;
  align-items: center;
  text-align: left;
}

@media (min-width: 768px) {
  .belief-inner {
    padding: 64px 40px;
  }

  .belief-item {
    padding: 2rem;
  }
}

@media (min-width: 900px) and (orientation: landscape) {
  .belief-inner {
    padding: 80px 120px;
    gap: 40px;
  }

  .belief-title {
    font-size: 2.4rem;
  }

  .belief-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 32px;
  }

  .belief-item {
    padding: 2rem;
  }
}
</style>
